export default "__VITE_ASSET__4ad602e5__"